"use strict";

exports.__esModule = true;
exports.DashboardTagController = DashboardTagController;
var _react = _interopRequireDefault(require("react"));
var _RestAPI = require("../../API/RestAPI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DashboardTagController(_ref) {
  var children = _ref.children;
  var options = _react["default"].useMemo(function () {
    return {
      method: "GET"
    };
  }, []);
  var _useRestApi = (0, _RestAPI.useRestApi)({
      url: "/api/v3/ui-config/dashboards/tags",
      options: options,
      formatDataProps: {}
    }),
    loading = _useRestApi.loading,
    data = _useRestApi.data;
  return children({
    loading: loading,
    data: data
  });
}